<div class="modal-header justify-content-between">
    <h4 class="modal-title header-13">
      Add New Payload Parameter
    </h4>
    <div>
     <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="close"
      />
    </button>
    </div>
  </div>
  
  <div class="payload-detail">
    <div class="sec-1">
      <div class="form-label"> Parameter Type </div>
      <div class="input-wrap d-flex">
        <select class="form-select w-50" [(ngModel)]="paramType">
          <option value="FORM_DATA"> Form-Data </option>
          <option value="X_WWW_FORM_URL_ENCODED"> x-www-form-url-encoded </option>
          <option value="RAW"> Raw </option>
        </select>
        <div [hidden]="paramType === 'RAW'" class="mx-3 add-btn" (click)="addNew()" (keydown.enter)="addNew()">
          <img src="assets/images/virtusa-icons/add-icon.svg" alt="add">
          <span> Add New {{ paramType }} </span>
        </div>
      </div>
      <div *ngIf="paramType === 'RAW'" class="mt-2">
        <span class="form-label"> Content-Type </span>
        <select [(ngModel)]="contentType" class="form-select w-50">
          <option value="APPLICATION_FORM_URLENCODED">Form URL Encoded</option>
          <option value="APPLICATION_JSON_UTF8">JSON (UTF-8)</option>
          <option value="APPLICATION_OCTET_STREAM">Binary Stream</option>
          <option value="APPLICATION_XML">XML</option>
          <option value="MULTIPART_FORM_DATA">Multipart Form Data</option>
          <option value="TEXT_HTML">HTML</option>
          <option value="TEXT_XML">Text-based XML</option>          
        </select>
      </div>
    </div>

    <div class="table-view mt-3" *ngIf="paramType != 'RAW'">
      <app-zorro-table
        tableId="'add-payload-param'"
        class="w-100"
        [columns]="tableData[paramType].columns"
        [data]="tableData[paramType].rows"
        (handleActions)="handleTableActions($event)"
      ></app-zorro-table>
    </div>
  </div>

  <div class="modal-footer border-0">
    <div class="d-flex justify-content-end">
      <button
        class="btn-accello-secondary  mx-2 open-btn"
        (click)="activeModal.dismiss('Cross click')"
      >
        Cancel
      </button>
      <button
        class="btn-accello-primary-light open-btn"
        (click)="save()"
      >
        Add
      </button>
    </div>
  </div>
  